import { useState, useEffect } from 'react';
import { hrmDashboardApi } from '../../../services/hrmApi';

export const useHRMPendingCounts = (hasPermission, user, enabled = true) => {
    const [counts, setCounts] = useState({
        hodLeaveRequests: 0,
        hodLeaveCancellations: 0,
        supervisorLeaveRequests: 0,
        supervisorLeaveCancellations: 0,
        tickets: 0,
        onboarding: 0,
        confirmations: 0,
        jobChanges: 0,
        separations: 0,
        requisitions: 0,
        hodAttendance: 0,
        supervisorAttendance: 0,
        adminAttendance: 0,
        loans: 0,
        otApprovals: 0,
        leaveTotal: 0,
        attendanceTotal: 0,
        lifecycleTotal: 0,
        recruitmentTotal: 0,
        payrollTotal: 0,
    });

    useEffect(() => {
        // Only fetch if user is logged in AND fetching is enabled
        if (!user || !enabled) return;

        let isMounted = true;

        const fetchCounts = async () => {
            try {
                const res = await hrmDashboardApi.getPendingCounts();
                if (isMounted && res?.data?.success && res?.data?.data) {
                    setCounts(res.data.data);
                }
            } catch (error) {
                console.error('Failed to fetch HRM pending counts:', error);
            }
        };

        fetchCounts();
        
        // Polling every 5 minutes (300000 ms)
        const interval = setInterval(fetchCounts, 300000);
        
        return () => {
            isMounted = false;
            clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, enabled]);

    return counts;
};

